<template>
  <div>
    <h2 v-t="'houseSettings'" class="text-2xl font-weight-semibold mb-4" />
    <v-card id="account-setting-card">
      <v-tabs v-model="currentTab" show-arrows>
        <v-tab v-for="tab in tabs" :key="tab.icon">
          <v-icon size="20" class="me-3">
            {{ tab.icon }}
          </v-icon>
          <span>{{ $t(tab.title) }}</span>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="currentTab" touchless>
        <v-tab-item v-if="$can(ACTIONS.READ, PRIVATE.SETTINGS.HOUSES)">
          <house-settings-tab-statuses />
        </v-tab-item>
        <v-tab-item v-if="$can(ACTIONS.READ, PRIVATE.SETTINGS.HOUSES)">
          <house-settings-tab-custom-fields />
        </v-tab-item>
        <v-tab-item v-if="$can(ACTIONS.READ, PRIVATE.SETTINGS.HOUSES)">
          <house-settings-tab-tags />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiText, mdiTagOutline, mdiBookEditOutline } from '@mdi/js'
// eslint-disable-next-line object-curly-newline
import HouseSettingsTabStatuses from './house-settings-tab-statuses/HouseSettingsTabStatuses.vue'
import HouseSettingsTabCustomFields from './house-settings-tab-custom-fields/HouseSettingsTabCustomFields.vue'
import HouseSettingsTabTags from './house-settings-tab-tags/HouseSettingsTabTags.vue'
import { ACTIONS, PRIVATE } from '@/plugins/acl/const'

export default {
  components: {
    HouseSettingsTabStatuses,
    HouseSettingsTabCustomFields,
    HouseSettingsTabTags,
  },
  setup() {
    const currentTab = ref(null)
    const tabs = [
      { icon: mdiText, title: 'statuses' },
      { icon: mdiBookEditOutline, title: 'customFields' },
      { icon: mdiTagOutline, title: 'tags' },
    ]

    return {
      tabs,
      currentTab,

      ACTIONS,
      PRIVATE,
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
